// extracted by mini-css-extract-plugin
module.exports = {"heading":"Form_heading__jGWeF","search":"Form_search__38K3P","btn-block":"Form_btn-block__1DjXr"};